import React from 'react';

import { T8y } from 'ui';

export const Meta14 = () => {
  return (
    <div>
      <T8y as="h1" center bold mb2>
        14 Yard Skip
      </T8y>
      <T8y as="h2" center mb2>
        Maximum Capacity for Large Projects
      </T8y>
      <T8y as="p" center mb3>
        The 14-yard skip offers maximum capacity for the largest of projects.
        It's perfect for significant commercial undertakings and extensive
        domestic renovations that generate substantial waste.
      </T8y>
      <T8y as="h3" center mb2>
        Projects Suited for a 14 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Demolition waste disposal <br /> Large-scale construction sites <br />
        Extensive home refurbishments <br /> Community and commercial clear-outs
      </T8y>
      <T8y as="h3" center mb2>
        Advantages of a 14 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Extra Large Size: Minimizes the need for multiple skips. <br />
        Versatile Waste Handling: Suitable for various non-hazardous waste
        types. <br />
        Project Efficiency: Streamlines waste management for large projects.
        <br />
        Safety Compliance: Helps maintain a clean and safe work environment.
        <br />
      </T8y>
      <T8y as="h4" center mb2>
        Scheduling a 14 Yard Skip Hire
      </T8y>
      <T8y as="p" center mb5>
        Reach out to our specialists to schedule your skip hire. We'll handle
        all the necessary arrangements, including permits and delivery, to
        provide a hassle-free experience tailored to your project's demands.
      </T8y>
    </div>
  );
};
